module.exports = __webpack_public_path__ + "4c02baf68937839213e8eb013a6ceb97.svg";